module.exports = __webpack_public_path__ + "img/medal.81cb8940.png";